import { RefObject, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectOffersHistorySpoilerData } from '../../../../selectors/offersHistory';

export const useLoader = (
  containerRef: RefObject<HTMLDivElement | null>,
  isViewChanged?: boolean,
): number | undefined => {
  const [loaderHeight, setLoaderHeight] = useState<number>();

  const { data, isFetching } = useSelector(selectOffersHistorySpoilerData);

  const showMoreButtonHeight = useMemo(() => (data?.totalCountText ? 40 : 0), [data]);

  useEffect(() => {
    /* istanbul ignore else */
    if (containerRef.current && data && !isFetching) {
      setLoaderHeight(containerRef.current.clientHeight + showMoreButtonHeight);
    }
  }, [containerRef, data, isFetching, showMoreButtonHeight, isViewChanged]);

  return loaderHeight;
};
